import { render, staticRenderFns } from "./treatment.vue?vue&type=template&id=0e8d9bb9&scoped=true"
import script from "./treatment.vue?vue&type=script&lang=js"
export * from "./treatment.vue?vue&type=script&lang=js"
import style0 from "./treatment.vue?vue&type=style&index=0&id=0e8d9bb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d9bb9",
  null
  
)

export default component.exports